import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import CalendarRange from './CalendarRange'
import DateNavigator from 'components/datepicker/DateNavigator'

import icons from 'icons'
const HomeIcon = icons.home

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'top',
  },
  dateToolbar: {
    textAlign: 'center',
  },
  datePicker: {
    marginTop: '0px',
  },
  calendar: {

  },
  homeButton: {
    textAlign: 'center',
  }
  
}))

const CalendarRender = ({
  children,
  calendar,
  toolbarButtons,
  choosenSlot,
  wrapTitle,
  onClickSlot,
  onEditDay,
  onHome,
}) => {

  const classes = useStyles()

  return (
    <div className={ classes.root }>
      {
        onHome && (
          <div className={ classes.homeButton }>
            <Button
              className={ classes.button }
              color="primary"
              onClick={ onHome }
            >
              <HomeIcon />&nbsp;Home
            </Button>
          </div>
        )
      }
      <div className={ classes.dateToolbar }>
        {
          calendar.parsedDate && (
            <DateNavigator
              disablePast={ calendar.admin ? false : true }
              className={ classes.datePicker }
              value={ calendar.parsedDate }
              min={ calendar.calendarConfig.min }
              max={ calendar.calendarConfig.max }
              condensed={ calendar.condensed }
              condensedDates={ calendar.condensedDates }
              navigatorButtons={ calendar.navigatorButtons }
              onMove={ calendar.move }
              onChange={ calendar.setDate }
            />
          )
        }
        {
          toolbarButtons
        }
      </div>
      { children }
      <div className={ classes.calendar }>
        <CalendarRange
          admin={ calendar.admin }
          data={ calendar.data }
          config={ calendar.config }
          choosenSlot={ choosenSlot }
          wrapTitle={ wrapTitle }
          onClickSlot={ onClickSlot }
          onEditDay={ onEditDay }
        />
      </div>
    </div>
  )
}

export default CalendarRender